'use client';

import React from 'react';

import { IconButton, SvgIconWrapper, Typography } from 'lighthouse';
import { Star5pointBoldMdSVG, Star5pointBoldSmSVG, Star5pointOutlineMdSVG, Star5pointOutlineSmSVG } from 'lighthouse-icons';

import { RatingStarIconProps, StarRatingProps } from './models';

/** Fixed orange for all rating stars — band colors stay on text/chips only. */
export const ratingStarFillClassName = 'text-warning';

export const RatingStarIcon = ({ size = 'sm', className = '' }: RatingStarIconProps) => (
    <SvgIconWrapper
        icon={size === 'md' ? Star5pointBoldMdSVG : Star5pointBoldSmSVG}
        size={size}
        className={`${ratingStarFillClassName} ${className}`}
    />
);

export const StarRating = ({ rating, onChange, size = 'sm', className = '' }: StarRatingProps) => {
    const isInteractive = !!onChange;
    const filledStars = Math.round(rating);
    const filledClassName = ratingStarFillClassName;
    const emptyClassName = 'text-gray-300';

    if (isInteractive) {
        return (
            <div dir='ltr' className={`flex flex-row-reverse items-center gap-1 ${className}`}>
                {[1, 2, 3, 4, 5].map((rate) => (
                    <IconButton key={rate} type='button' className='relative p-1' aria-label={`${rate} ستاره`} onClick={() => onChange(rate)}>
                        {size === 'md' && (
                            <SvgIconWrapper
                                icon={rate <= filledStars ? Star5pointBoldMdSVG : Star5pointOutlineMdSVG}
                                size={'md'}
                                className={rate <= filledStars ? filledClassName : emptyClassName}
                            />
                        )}

                        {size === 'sm' && (
                            <SvgIconWrapper
                                icon={rate <= filledStars ? Star5pointBoldSmSVG : Star5pointOutlineSmSVG}
                                size={'sm'}
                                className={rate <= filledStars ? filledClassName : emptyClassName}
                            />
                        )}
                        {rate > filledStars && (
                            <Typography className='absolute left-0 right-0 top-[9px] text-[10px] text-gray-400 opacity-30'>{rate}</Typography>
                        )}
                    </IconButton>
                ))}
            </div>
        );
    }

    return (
        <div className={`flex items-center gap-0.5 ${className}`} role='img' aria-label={`${rating} از ۵ ستاره`}>
            {[1, 2, 3, 4, 5].map((rate) =>
                size === 'md' ? (
                    <SvgIconWrapper
                        key={rate}
                        icon={rate <= filledStars ? Star5pointBoldMdSVG : Star5pointOutlineMdSVG}
                        size={'md'}
                        className={rate <= filledStars ? filledClassName : emptyClassName}
                    />
                ) : (
                    <SvgIconWrapper
                        key={rate}
                        icon={rate <= filledStars ? Star5pointBoldSmSVG : Star5pointOutlineSmSVG}
                        size={'sm'}
                        className={rate <= filledStars ? filledClassName : emptyClassName}
                    />
                )
            )}
        </div>
    );
};
